import DefaultLayout from '~/components/layouts/DefaultLayout';

export function IntegrationPickerRow({
  title,
  subtitle,
  children,
  secondary = false,
}) {
  ('h-full border-t border-gray-600 bg-gray-0 border-opacity-10');
  return (
    <div
      className={classnames([
        'px-10',
        'py-6',
        secondary
          ? 'h-full border-t border-gray-600 bg-gray-0 border-opacity-10'
          : null,
      ])}>
      <h3 className="text-base font-medium">{title}</h3>
      <p className="mb-6 text-base text-gray-600">{subtitle}</p>
      <div className="flex flex-row flex-wrap w-full">{children}</div>
    </div>
  );
}

export const IntegrationPickerLayout = ({
  title,
  subtitle,
  loading,
  tile,
  children,
}) => {
  return (
    <DefaultLayout
      background="white"
      title={title}
      subtitle={subtitle}
      loading={loading}
      tile={tile}
      shadow>
      <div className="flex flex-col flex-grow">{children}</div>
    </DefaultLayout>
  );
};
